/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ArticoloPraticaStatus } from './articolo-pratica-status';


export interface VoucherArticoloRigaBackofficeDTO { 
    id_articolo_pratica?: string;
    version_articolo?: number;
    titolo?: string;
    valore?: number;
    stato?: ArticoloPraticaStatus;
    id_transazione?: string;
}



